export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        prospects: action.prospects,
      };

    case 'CREATE':
      return {
        ...state,
        prospects: [action.prospect, ...state.prospects],
      };

    case 'UPDATE':
      return {
        ...state,
        prospects: state.prospects.map((item) => (item.id === action.prospect.id ? action.prospect : item)),
      };

    case 'DELETED':
      return {
        ...state,
        prospects: state.prospects.filter((item) => item.id !== action.prospectId),
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
